import { lazy } from "react";
import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";

const CallsHistory = lazy(() => import("./CallsHistory"));

export type CallsPagesNavigationParams = {
  callsHistory: PageNavParams;
};

export const callsPagesNavigationConfig: ModulePagesConfig<CallsPagesNavigationParams> =
  {
    callsHistory: {
      element: <CallsHistory />,
      path: "calls",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.calls,
    },
  };
